import {
  Download1Stroke,
  PrinterStroke,
  RefreshCircle1ClockwiseStroke,
  Search1Stroke,
  SignPostLeftStroke
} from '@lineiconshq/free-icons';
import React from 'react';
import { ActionBarV2, ActionButtonV2, AritoIcon, MenuButtonV2 } from '@/components/custom/erp';
import { useBangKePhieuXuatTraNCCContext } from '../context';
import { useAuth } from '@/contexts/auth-context';

interface Props {
  onSearchClick: () => void;
  onRefreshClick: () => void;
  onFixedColumnsClick: () => void;
  onExportDataClick: () => void;
  onPrintClick: () => void;
  onEditPrintTemplateClick: () => void;
  fromDate?: string | Date;
  toDate?: string | Date;
  className?: string;
}

export function ActionBar({
  onSearchClick,
  onRefreshClick,
  onFixedColumnsClick,
  onExportDataClick,
  onPrintClick,
  onEditPrintTemplateClick,
  fromDate,
  toDate,
  className
}: Props) {
  // Format date to dd/mm/yyyy
  const formatDateToDDMMYYYY = (date: string | Date): string => {
    if (!date) return '';

    let dateObj: Date;
    if (date instanceof Date) {
      dateObj = date;
    } else {
      dateObj = new Date(date);
    }

    if (isNaN(dateObj.getTime())) return '';

    const day = dateObj.getDate().toString().padStart(2, '0');
    const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
    const year = dateObj.getFullYear();

    return `${day}/${month}/${year}`;
  };

  // Create date range display
  const getDateRangeDisplay = () => {
    if (!fromDate || !toDate) return '';

    const formattedFromDate = formatDateToDDMMYYYY(fromDate);
    const formattedToDate = formatDateToDDMMYYYY(toDate);

    if (formattedFromDate && formattedToDate) {
      return `Từ ngày ${formattedFromDate} đến ngày ${formattedToDate}`;
    }

    return '';
  };
  const { loading } = useAuth();

  const dateRangeText = getDateRangeDisplay();
  return (
    <ActionBarV2
      className={className}
      titleComponent={
        <div className='flex flex-col'>
          <h1 className='text-xl font-bold'>Bảng kê phiếu xuất trả lại nhà cung cấp</h1>
          {dateRangeText && (
            <p className='mt-1 text-sm text-gray-600'>
              <span className='mr-2 inline-block h-2 w-2 rounded-full bg-red-600'></span>
              {dateRangeText}
            </p>
          )}
        </div>
      }
    >
      <ActionButtonV2 icon={Search1Stroke} title='Tìm kiếm' onClick={onSearchClick} variant='primary' />
      <ActionButtonV2
        icon={RefreshCircle1ClockwiseStroke}
        title='Làm mới'
        variant='destructive'
        onClick={onRefreshClick}
      />
      <ActionButtonV2 icon={SignPostLeftStroke} title='Cố định cột' onClick={onFixedColumnsClick} />
      <ActionButtonV2 icon={Download1Stroke} title='Xuất dữ liệu' onClick={onExportDataClick} disabled={loading} />
      <ActionButtonV2 icon={PrinterStroke} title='In' onClick={onPrintClick} />
      <MenuButtonV2
        title='Khác'
        items={[
          {
            title: 'Sửa mẫu in',
            icon: <AritoIcon icon={864} />,
            onClick: onEditPrintTemplateClick,
            group: 0
          }
        ]}
      />
    </ActionBarV2>
  );
}
